import { useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { selectGenerationRun } from '../automationStudioNewSelectors';
import { RUN_STATUS } from '../constants';
import { setStreamedInstructions } from '../automationStudioNewSlice';
import { mergeExecutionFlowIntoInstructions } from '../executionFlowMerger';

/**
 * Streams executionFlow + screenshots + testSteps into plan draft during generation.
 */
export default function useAutomationStudioNewGenerationStream() {
    const dispatch = useDispatch();
    const store = useStore();
    const generationRun = useSelector(selectGenerationRun);

    useEffect(() => {
        if (generationRun.status !== RUN_STATUS.RUNNING) return;
        if (!generationRun.executionFlow?.executions?.length) return;

        const instructions = store.getState().automationStudioNew.planDraft.instructions;
        const merged = mergeExecutionFlowIntoInstructions(
            instructions,
            generationRun.executionFlow,
            generationRun.screenshots,
            generationRun.testStepsByExecutionId
        );
        dispatch(setStreamedInstructions(merged));
    }, [
        dispatch,
        store,
        generationRun.status,
        generationRun.executionFlow,
        generationRun.screenshots,
        generationRun.testStepsByExecutionId,
    ]);
}
